import React from 'react'
import './styles/ListSiteNew.scss'
import { publicConfiguration } from '../../config'

import b1 from '../../assets/images/tamplates/business/business-1.png'
import b2 from '../../assets/images/tamplates/business/business-2.png'
import b3 from '../../assets/images/tamplates/business/business-3.png'
import b4 from '../../assets/images/tamplates/business/business-4.png'

import c1 from '../../assets/images/tamplates/card/card-1.png'
import c2 from '../../assets/images/tamplates/card/card-2.png'
import c3 from '../../assets/images/tamplates/card/card-3.png'
import c4 from '../../assets/images/tamplates/card/card-4.png'

import l1 from '../../assets/images/tamplates/landing/landing-1.png'
import l2 from '../../assets/images/tamplates/landing/landing-2.png'
import l3 from '../../assets/images/tamplates/landing/landing-3.png'
import l4 from '../../assets/images/tamplates/landing/landing-4.png'
import l5 from '../../assets/images/tamplates/landing/landing-5.png'
import l6 from '../../assets/images/tamplates/landing/landing-6.png'

import o1 from '../../assets/images/tamplates/online-store/online-store-1.png'

const portfolioUrl = (path) => `${publicConfiguration.portfolioBaseUrl}${path}`;

export default class ListExample extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            slides: 0,
            // arrBox: [
            //     <figure ref={(node) => (this.box = node)} className="list-site-new--container--block--box">
            //     </figure>,
            //     <figure className="list-site-new--container--block--box">
            //     </figure>,
            //     <figure className="list-site-new--container--block--box">
            //     </figure>,
            //     <figure className="list-site-new--container--block--box">
            //     </figure>,
            //     <figure className="list-site-new--container--block--box">
            //     </figure>
            // ],
            comp: false,
            currTransl: [],
            num: 0,
            // list: [
            //     {
            //         img: imOne
            //     },
            // ],
        }
    }

    render() {
        let alls = [
            [
                {
                    img: b1,
                    href: portfolioUrl('/business/1/')
                },
                {
                    img: b2,
                    href: portfolioUrl('/business/2/')
                },
                {
                    img: b3,
                    href: portfolioUrl('/business/3/')
                },
                {
                    img: b4,
                    href: portfolioUrl('/business/4/')
                },
            ],
            [
                {
                    img: c1,
                    href: portfolioUrl('/card/1/')
                },
                {
                    img: c2,
                    href: portfolioUrl('/card/2/')
                },
                {
                    img: c3,
                    href: portfolioUrl('/card/3/')
                },
                {
                    img: c4,
                    href: portfolioUrl('/card/4/')
                },
            ],
            [
                {
                    img: l1,
                    href: portfolioUrl('/landing/1/')
                },
                {
                    img: l2,
                    href: portfolioUrl('/landing/2/')
                },
                {
                    img: l3,
                    href: portfolioUrl('/landing/3/')
                },
                {
                    img: l4,
                    href: portfolioUrl('/landing/4/')
                },
                {
                    img: l5,
                    href: portfolioUrl('/landing/5/')
                },
                {
                    img: l6,
                    href: portfolioUrl('/landing/6/')
                },
            ],
            [
                {
                    img: o1,
                    href: portfolioUrl('/online-store/1/')
                },
            ],
        ]

        console.log('asdasd', alls)

        return (
            <React.Fragment>
                <div className="list-site-new" id="list-site-new">
                    <div className="list-site-new--container">
                        <div className="list-site-new--container--slide">
                            <div className="list-site-new--container--slide--move">
                                {
                                    this.props.item && alls[this.props.item].map((item, index) => {
                                        return (
                                            <a
                                                key={index}
                                                href={item.href}
                                                className="list-site-new--container--slide--move--box"
                                                target="_blank"
                                            >
                                                <img src={item.img} alt=""/>
                                            </a>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        {/*<div className="list-site-new--container--slide">*/}
                        {/*    <div className="list-site-new--container--slide--move--two">*/}
                        {/*        {*/}
                        {/*            this.state.list.map((item, index) => {*/}
                        {/*                return (*/}
                        {/*                    <div*/}
                        {/*                        key={index}*/}
                        {/*                        className="list-site-new--container--slide--move--two--box"*/}
                        {/*                    >*/}
                        {/*                        <img src={item.img} alt=""/>*/}
                        {/*                    </div>*/}
                        {/*                )*/}
                        {/*            })*/}
                        {/*        }*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="list-site-new--container--slide">*/}
                        {/*    <div className="list-site-new--container--slide--move">*/}
                        {/*        {*/}
                        {/*            this.state.listNew.map((item, index) => {*/}
                        {/*                return (*/}
                        {/*                    <div*/}
                        {/*                        key={index}*/}
                        {/*                        className="list-site-new--container--slide--move--box"*/}
                        {/*                    >*/}
                        {/*                        <img src={item.img} alt=""/>*/}
                        {/*                    </div>*/}
                        {/*                )*/}
                        {/*            })*/}
                        {/*        }*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
